<div class="form">
  <div class="title">{{ title | translate }}</div>

  <mat-dialog-content>
    <div class="form-item">
      <label class="form-item__label">{{ 'label.YourSkills' | translate }}</label>

      <div class="skill-search">
        <input
          class="skill-search__input"
          [class.skill-search__input--open]="skillInput.value && suggestions"
          type="text"
          [formControl]="skillInput"
          [placeholder]="'label.SkillsExample' | translate"
          (keydown.enter)="addCustomSkill()"
        />

        @if (canAddCustomSkill) {
          <button
            type="button"
            class="skill-search__add"
            [title]="'label.SkillsAddNew' | translate"
            [attr.aria-label]="'label.SkillsAddNew' | translate"
            (click)="addCustomSkill()"
          >
            <svg-icon src="/assets/icons/plus-small.svg" class="skill-search__add-icon"></svg-icon>
          </button>
        }

        @if (skillInput.value && suggestions) {
          <div class="suggestions">
            @for (item of suggestions.queryResultItems; track item.skillId) {
              <div class="suggestions__item" (click)="selectSkill(item)">
                @if (getMatchSplit(item.name); as parts) {
                  <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
                }
              </div>
            }
            @for (item of suggestions.suggestedItems; track item.skillId) {
              <div class="suggestions__item" (click)="selectSkill(item)">
                @if (getMatchSplit(item.name); as parts) {
                  <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
                }
              </div>
            }
          </div>
        }

        @if (draftSkills; as skills) {
          @if (skills.length > 0) {
          <div class="reorder-hint">
            <svg-icon src="/assets/icons/drag-dots.svg" class="reorder-hint__icon"></svg-icon>
            {{ 'label.SkillsReorderHint' | translate }}
          </div>
          <div class="chosen-skills-wrapper">
          <div class="chosen-skills">
            <hrra-skills
              [skills]="skills"
              [userType]="userType"
              (onRemoveSkill)="removeSkill($event)"
              (onReorderSkills)="reorderSkills($event)"
            ></hrra-skills>
          </div>
          </div>
          }
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="buttons">
      <app-button
        (click)="save()"
        [disabled]="saveDisabled"
        [text]="'label.Save' | translate"
        [type]="buttonType.coloured"
        [typeAttribute]="buttonAttributeType.submit"
        class="button-save"
      ></app-button>
      <app-button
        [mat-dialog-close]="true"
        [text]="'label.Cancel' | translate"
        [type]="buttonType.uncoloured"
        [typeAttribute]="buttonAttributeType.button"
      ></app-button>
    </div>
  </mat-dialog-actions>
</div>
